import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { IconButton, Tooltip } from '@material-ui/core';
import RecieptPopup from './RecieptPopup';
import { useSelector } from 'react-redux';
import { CommonConfig } from '../../../config/common-config';
import axios from 'axios';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { userType } from '../../../config/usertypeValue';

const useStyles = makeStyles((theme) => ({
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarks: {
        fontSize: '1rem',
        borderBottom: '1px solid #ccc',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    }
}));


const PopUp = ({ row, post, generate, mode, Icon }) => {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();
    const history = useHistory();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails.tennantName;
    const userName = tennantDetails.userName;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [handleOpen, setHandleOpen] = React.useState();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;

    //console.log(Icon ," icon ");
    //console.log(mode ,"mode");

    const handleClickOpen = () => {

        console.log('location', usertype);
        // setOpen(true);

        const axiosConfig = {
            headers: {
                Authorization: bearerToken,
            },
        };

        if (usertype === 'SuperAdmin') {
            handleNavigate();
        } else {
            const apiUrlGenInvoiceOnServId = `${CommonConfig.dev.baseUrl}/api/auth/getInvoiceByServiceId/${row.serviceId}/${tennantName}`;

            axios
                .get(apiUrlGenInvoiceOnServId, axiosConfig)
                .then((res) => {
                    console.log('SERVICE ID???', res.data, usertype);
                    if (res && res.data && res.data.pickerEmailId) {
                        console.log('aaaaaa', userName, res.data.pickerEmailId)
                        if (userName === res.data.pickerEmailId) {
                            console.log('enter');
                            // setHandleOpen(false);
                            handleNavigate();
                        } else {
                            console.log('popup')
                            // setHandleOpen(true);
                            setDialogOpen(true);
                        }
                    } else {
                        console.log('aaaaaaa')
                        handleNavigate();
                    }
                })
                .catch((error) => { });
        }

        // if (handleOpen === true) {

        // } else {
        // }
    }

    const handleNavigate = () => {
        if ((post === 'admin') && (history.location.pathname === '/menu/indInvoice')) {
            history.push({
                pathname: '/menu/updateIndInvoice',
                // row,
                // buyer_type: 'Individual'
                state: { row, buyer_type: 'Individual' },
            });
        }
        else if ((post === 'admin') && (history.location.pathname === '/menu/corpInvoice')) {
            history.push({
                pathname: '/menu/updateIndInvoice',
                // row,
                // buyer_type: 'Corporate'
                state: { row, buyer_type: 'Corporate' },
            });
        }
        else {
            history.push({
                pathname: '/menu/updateInvoice',
                // row,
                state: { row },
            });
        }
    }

    const handleClose = () => {
        //console.log("closed PopUp");
        setOpen(false);
    };
    return (
        <>
            <Tooltip title={mode} onClick={handleClickOpen}>
                <IconButton aria-label={mode}>
                    {/* <Icon /> */}
                    <ReceiptIcon />
                </IconButton>
            </Tooltip>

            <div>
                {post === 'superAdmin' && open === true && (
                    <Link openP={open} row={row} onGenerate={generate} />
                )}

                {post === 'admin' && open === true && (
                    <RecieptPopup openP={open} handleClose={handleClose} post={post} row={row} onGenerate={generate} />
                )}
            </div>
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                {/* <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        The Invoice is being processed by {usertype === 'Support Team' ? 'Admin' : 'Support'} team
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => setDialogOpen(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PopUp;
